export default {
    setInterests(state, payload) {
        state.interests = payload
    },
    setHasSubmitted(state, payload) {
        state.hasSubmitted = payload
    }
}
